/**CORE LIBRARIES IMPORT */
import React from "react";

const PrivacyPolicy=()=>{
    return(
        <>

        </>
    )
}

export default PrivacyPolicy;